import { QueryBase } from './origin-fetch';
import { engageLabCore } from '@jg/qiankun-micro-tool';

export class BusinessError extends Error {
  code: number;
  constructor(code: number, message: string) {
    super(message);
    this.name = 'BusinessError';
    this.code = code;
  }
}

let showMessage = true;
export default (res: QueryBase<any>, autoTip: boolean) => {
  // console.log('error-interceptor', res, autoTip);
  const redirectCodes = [40101, 40102, 40103, 40106, 40107];
  const whiteListCodes = [
    200306, 200307, 200308, 200309, 200310, 200311, 200312, 200313, 200314, 200315, 200316, 200317,
    200318, 200319, 200320,
  ];
  const noPermissionCodes = [40100, 40104];
  if (redirectCodes.includes(res.code)) {
    if (showMessage) {
      engageLabCore.modal.loginFail();
      showMessage = false;
    }
    setTimeout(() => {
      showMessage = true;
    }, 1000);
  } else if (noPermissionCodes.includes(res.code)) {
    const current = history.state.current as string;
    location.hash = `${current.substring(0, current.indexOf('/', 15))}/403`;
  } else if (autoTip && !whiteListCodes.includes(res.code)) {
    const temp = res as any;
    const otherMsg = temp.content || temp.message; //防止其它系统不符合规范的报错，做一下兼容性拦截
    throw new BusinessError(res.code, res.msg || otherMsg);
  }
};
